// Optional-field notes ("'Site Access Level' was not captured", provenance warnings) only help while
// something required is still missing; under the green "Everything required is captured" they are
// noise (QA #19).
export const shouldShowCaptureNotes = (ready: boolean, noteCount: number): boolean => !ready && noteCount > 0;
